import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';

import { HisSearchResultComponent } from 'hisng';

@Component( {
    templateUrl: './jobadvertisement-search-result.component.html'
} )
export class JobAdvertisementSearchResultComponent {

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent!: HisSearchResultComponent;

    constructor( private readonly cd: ChangeDetectorRef ) { }

    page( event: { first: number; rows: number } ) {
        this.searchResultComponent.loadPage( event.first );
        this.searchResultComponent.onPage( event );

        // NG0100: Expression has changed after it was checked fix
        // loadPage und onPage werden aufgerufen, nachdem die Change Detection von HisSearchResultComponent abgeschlossen ist.
        // Daher muss die Change Detection nochmal manuell angestoßen werden
        this.cd.detectChanges();
    }
}
